import NamedDto from 'modules/base/dto/NamedDto';

export default class PredictionDeviceTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.project = null;
		/** @type {NamedDto} */
		this.deviceType = null;
		/** @type {Date} */
		this.lastSeen = null;
		/** @type {NamedDto|string} */
		this.predictionType = null;
		/** @type {NamedDto} */
		this.sourceDevice = null;
	}

	/**
	 * @typedef {Object} _PredictionDeviceTableDtoProps
	 * @property {NamedDto} project
	 * @property {NamedDto} deviceType
	 * @property {Date} lastSeen
	 * @property {NamedDto|string} predictionType
	 * @property {NamedDto} sourceDevice
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PredictionDeviceTableDtoProps} PredictionDeviceTableDtoProps
	 */
	/**
	 *
	 * @param {PredictionDeviceTableDtoProps} props
	 * @returns {PredictionDeviceTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.project = props.project != null ? new NamedDto().setup(props.project) : null;
		this.deviceType = props.deviceType != null ? new NamedDto().setup(props.deviceType) : null;
		this.lastSeen = props.lastSeen != null ? new Date(props.lastSeen) : null;
		this.predictionType =
			props.predictionType != null && typeof props.predictionType === 'object'
				? new NamedDto().setup(props.predictionType)
				: props.predictionType;
		this.sourceDevice = props.sourceDevice != null ? new NamedDto().setup(props.sourceDevice) : null;
		return this;
	}

	getAsString(key) {
		if (key === 'predictionType') {
			return this.predictionType && typeof this.predictionType === 'object'
				? this.predictionType.getAsString('name')
				: super.getAsString(key);
		}
		return super.getAsString(key);
	}
}
